export default {
  methods: {
    selectAll(indexAllSelected, filterSelected, filterData, filteredFilterData = []) {
      if (filterSelected.includes('SELECIONAR TUDO')) {
        if (!this.allFilterSelected[indexAllSelected]) {
          this.allFilterSelected[indexAllSelected] = true;
          // Substitui todas as opções selecionadas pelas opções disponíveis
          filterSelected.splice(0, filterSelected.length, ...(filteredFilterData.length ? filteredFilterData : filterData));
        } else {
          // Remove a opção 'SELECIONAR TUDO' juntamente com a opção selecionada
          const index = filterSelected.indexOf('SELECIONAR TUDO');
          this.allFilterSelected[indexAllSelected] = false;

          if (index !== -1) {
            filterSelected.splice(index, 1);
          }
        }
      } else {
        // Se a opção 'SELECIONAR TUDO' não estiver incluída
        if (this.allFilterSelected[indexAllSelected]) {
          // Remove todas as opções selecionadas
          this.allFilterSelected[indexAllSelected] = false;
          filterSelected.splice(0, filterSelected.length);
        } else {
          if (filterSelected.length === (filteredFilterData.length ? filteredFilterData : filterData).length - 1) {
            // Marca todas as opções como selecionadas
            this.allFilterSelected[indexAllSelected] = true;
            // Substitui todas as opções selecionadas pelas opções disponíveis
            filterSelected.splice(0, filterSelected.length, ...(filteredFilterData.length ? filteredFilterData : filterData));
          }
        }
      }
    },

    filterArray(selectedItems, availableItems, filterIndex, key = null) {
      // Se não houver valores válidos, retorna vazio
      if (!selectedItems || !availableItems || availableItems.length === 0) {
        this.filterSelected[filterIndex] = Array.isArray(selectedItems) ? [] : '';
        return;
      }

      const field = this.filters && this.filters[filterIndex] ? this.filters[filterIndex] : {};
      const itemValue = field.itemValue;
      const getItemValue = (item) => {
        if (!item || typeof item !== 'object') return item;

        return itemValue ? item[itemValue] : (item.value ?? item.text);
      };

      // Caso seja string, apenas verifica se existe no array
      if (typeof selectedItems === 'string') {
        if (!availableItems.some((item) => getItemValue(item) === selectedItems)) {
          this.filterSelected[filterIndex] = '';
        }
        return;
      }

      // Caso seja array
      if (Array.isArray(selectedItems)) {
        // Detecta se é array de objetos e chave de comparação foi informada
        const isObjectArray = key && selectedItems.length > 0 && typeof selectedItems[0] === 'object';

        if (isObjectArray) {
          // Filtra pelo valor da propriedade 'key'
          selectedItems = selectedItems.filter((item) => availableItems.some((av) => av[key] === item[key]));
        } else {
          // Filtra pelo valor configurado mesmo quando as opções são objetos
          selectedItems = selectedItems.filter((item) =>
            availableItems.some((availableItem) => getItemValue(availableItem) === getItemValue(item))
          );
        }

        // Lógica "SELECIONAR TUDO"
        const isAllSelected = selectedItems.includes('SELECIONAR TUDO');
        const totalItems = availableItems.length;
        const hasSelectedItems = selectedItems.length === (isAllSelected ? totalItems : totalItems - 1);

        if (!isAllSelected && hasSelectedItems && totalItems > 1) {
          selectedItems.unshift('SELECIONAR TUDO');
          this.allFilterSelected[filterIndex] = true;
        } else if (isAllSelected && !hasSelectedItems) {
          selectedItems.shift();
          this.allFilterSelected[filterIndex] = false;
        }
      }

      // Atualiza o valor reativo
      this.filterSelected[filterIndex] = selectedItems;
    },

    customFilterWithParam(extraValue) {
      return (value, query, item) => {
        const field = this.filters && this.filters[extraValue] ? this.filters[extraValue] : {};
        const textKey = field.itemText || 'text';
        const itemObject = value && typeof value === 'object' ? value : item && typeof item === 'object' ? item : null;
        const itemText = itemObject ? (itemObject[textKey] ?? itemObject.value) : typeof item === 'string' ? item : value;
        const textValue = (itemText ?? '').toString().toLowerCase();
        const searchQuery = (query ?? '').toString().toLowerCase();

        const matches = textValue.includes(searchQuery) || itemText === 'SELECIONAR TUDO';

        // Garante que o objeto existe e é reativo
        if (!this.filterSearch) {
          this.$set(this, 'filterSearch', {});
        }

        // Cria um array para armazenar os itens filtrados daquele campo
        if (!Array.isArray(this.filterSearch[extraValue])) {
          this.$set(this.filterSearch, extraValue, []);
        }

        // Se deu match, adiciona o texto do item (sem duplicar)
        if (matches) {
          if (!this.filterSearch[extraValue].includes(itemText)) {
            this.filterSearch[extraValue].push(itemText);
          }
        } else {
          // Se o item não corresponde, remove caso esteja presente
          const index = this.filterSearch[extraValue].indexOf(itemText);
          if (index !== -1) {
            this.filterSearch[extraValue].splice(index, 1);
          }
        }

        return matches;
      };
    }
  }
};
